import useReveal from "../../hooks/useReveal";

const benefits = ["Live score from Apple Watch", "Heart rate and calories via HealthKit", "Match history on iPhone"];

export default function HealthSection() {
	const ref = useReveal(0);
	return (
		<section className="py-20 md:py-28" style={{ background: "var(--color-night)" }} aria-labelledby="health-heading">
			<div className="container mx-auto px-4 sm:px-6">
				<div ref={ref} className="reveal health-panel grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-20 items-end p-7 md:p-12" style={{ background: "var(--color-night-2)", border: "var(--rule-fine) solid var(--color-night-rule)" }}>
					<div>
						<p className="font-display font-bold uppercase mb-4" style={{ fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-label)", color: "var(--color-accent)" }}>Beyond the scoreboard</p>
						<h2 id="health-heading" className="font-display font-bold uppercase" style={{ color: "var(--color-on-night)", fontSize: "var(--text-display-s)", lineHeight: "var(--lh-tight)" }}>The match tells more than one story.</h2>
					</div>
					<div>
						<p style={{ color: "var(--color-on-night-muted)", fontSize: "var(--text-lg)", lineHeight: "var(--lh-body)" }}>On Apple Watch, Racketly uses HealthKit during your match to record heart rate and calories. Your score, physical effort and match history stay connected — without pulling your focus away from play.</p>
						<ul className="mt-7 grid gap-3" style={{ color: "var(--color-on-night)" }}>
							{benefits.map((benefit) => <li key={benefit} className="flex items-center gap-3 font-display font-bold uppercase" style={{ fontSize: "var(--text-md)", letterSpacing: "0.03em" }}><span aria-hidden="true" className="health-check">✓</span>{benefit}</li>)}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
}
